import failedImg from "../../../assets/images/failed_tire.png";
import LoadingDots from "../../atoms/Loaders/BouncingDots";
import { useSelector } from "react-redux";

export default function LoadingFailedPage() {
  const { code } = useSelector((state) => state.loadingTracker);
  return (
    <div className="m-12 overflow-hidden rounded-lg bg-white ">
      <div className="px-4 py-5 sm:p-6 text-center">
        <img
          className="max-h-24 mx-auto"
          alt="confused tire guy"
          src={failedImg}
        />
        <h1 className="font-serif text-2xl font-bold text-gray-800">
          Sorry! We couldn't load what you were looking for.
        </h1>
        <LoadingDots />
        <p className="font-serif text-gray-500 mt-6">
          Please refresh the page to try again. If the issue persists, please
          contact customer service to get help immediately and report this
          issue.
        </p>
        <p className=" text-gray-800 mt-2 text-sm">{code}</p>
      </div>
    </div>
  );
}
